import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Heart, Clock } from 'lucide-react';

const DoaDzikir = () => {
    const doaList = [
        { emoji: '☀️', label: 'Dzikir Pagi' },
        { emoji: '🌇', label: 'Dzikir Petang' },
        { emoji: '🍽️', label: 'Doa Makan' },
        { emoji: '🚪', label: 'Doa Keluar Rumah' },
        { emoji: '🛏️', label: 'Doa Sebelum Tidur' },
        { emoji: '🌙', label: 'Doa Bangun Tidur' },
        { emoji: '💧', label: 'Doa Masuk Kamar Mandi' },
    ];

    return (
        <div className="pt-24 min-h-screen bg-[#081c1a] animate-fade-in-up flex flex-col">
            <div className="container mx-auto px-6 py-8 flex-1">
                <Link to="/belajar-islam" className="inline-flex items-center gap-2 text-muted-foreground hover:text-gold transition-colors mb-10 group">
                    <ArrowLeft size={18} className="group-hover:-translate-x-1 transition-transform" />
                    Kembali ke Belajar Islam
                </Link>

                <div className="flex flex-col items-center justify-center min-h-[70vh] text-center">
                    <div className="relative mb-10">
                        <div className="w-40 h-40 rounded-full bg-rose-500/5 border border-rose-500/10 flex items-center justify-center mx-auto">
                            <div className="w-28 h-28 rounded-full bg-rose-500/10 border border-rose-500/20 flex items-center justify-center">
                                <Heart size={52} className="text-rose-400" />
                            </div>
                        </div>
                        <div className="absolute -top-2 -right-2 w-8 h-8 bg-gold/20 rounded-full border border-gold/40 flex items-center justify-center">
                            <Clock size={14} className="text-gold" />
                        </div>
                    </div>



                    <h1 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6">
                        Segera <span className="text-gold">Hadir</span>
                    </h1>
                    <p className="text-xl text-muted-foreground max-w-xl leading-relaxed mb-10">
                        Kumpulan doa pendek dan dzikir harian untuk menemani aktivitas Anda. Kami sedang menyiapkan konten yang mudah dibaca dan diamalkan.
                    </p>

                    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 max-w-2xl w-full mb-12">
                        {doaList.map((d) => (
                            <div key={d.label} className="glass-card px-4 py-3 rounded-xl border border-white/10 flex flex-col items-center gap-1">
                                <span className="text-2xl">{d.emoji}</span>
                                <span className="text-xs text-muted-foreground text-center">{d.label}</span>
                            </div>
                        ))}
                    </div>

                    <div className="glass-card p-6 rounded-2xl border border-white/10 max-w-sm w-full">
                        <p className="text-muted-foreground text-sm mb-1">Tim kami sedang bersiap</p>
                        <div className="w-full h-2 bg-white/10 rounded-full overflow-hidden">
                            <div className="h-full bg-gradient-to-r from-rose-500 to-gold rounded-full" style={{ width: '60%' }} />
                        </div>
                        <p className="text-xs text-muted-foreground mt-2">60% selesai</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DoaDzikir;
